import { render, staticRenderFns } from "./DrugSynonyms.vue?vue&type=template&id=74cc3654&scoped=true"
import script from "./DrugSynonyms.vue?vue&type=script&lang=js"
export * from "./DrugSynonyms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cc3654",
  null
  
)

export default component.exports